export default {"src":"/_next/static/media/location_on.82dda21d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};